export const PAYMENT_METHOD_OPTIONS = [
  {
    value: 0,
    label: 'Credit/Debit Card',
  },
  {
    value: 1,
    label: 'ACH',
  },
];
